export default __webpack_public_path__ + "970f021405aff54baaa4f121c659b7a6.jpg";